import { MailView } from "./components/MailView";

type CustomerMailPageProps = {
  companyId: string;
};

/**
 * The customer Emails tab: the mail filed against one customer. Mounted inside the legacy
 * customer dashboard, below its tab bar.
 */
export const CustomerMailPage = ({ companyId }: CustomerMailPageProps) => (
  <div className="px-3 pt-3">
    <MailView source={{ kind: "customer", companyId }} />
  </div>
);
